import React from 'react'
import PropTypes from 'prop-types'

const ClockIcon = ({ width = 18, height = 20, color = '#101820' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.75 20.5833C7.73878 20.5833 5.80992 19.7844 4.38777 18.3622C2.96562 16.9401 2.16667 15.0112 2.16667 13C2.16667 10.9888 2.96562 9.05993 4.38777 7.63777C5.80992 6.21562 7.73878 5.41667 9.75 5.41667C11.7612 5.41667 13.6901 6.21562 15.1122 7.63777C16.5344 9.05993 17.3333 10.9888 17.3333 13C17.3333 15.0112 16.5344 16.9401 15.1122 18.3622C13.6901 19.7844 11.7612 20.5833 9.75 20.5833ZM17.3658 6.9225L18.9042 5.38417C18.4167 4.83167 17.9292 4.33333 17.3767 3.85667L15.8383 5.41667C14.1592 4.05167 12.0467 3.25 9.75 3.25C7.16414 3.25 4.68419 4.27723 2.85571 6.10571C1.02723 7.93419 0 10.4141 0 13C0 15.5859 1.02723 18.0658 2.85571 19.8943C4.68419 21.7228 7.16414 22.75 9.75 22.75C15.1667 22.75 19.5 18.3842 19.5 13C19.5 10.7033 18.6983 8.59083 17.3658 6.9225ZM8.66667 14.0833H10.8333V7.58333H8.66667M13 0H6.5V2.16667H13V0Z"
        fill={color}
      />
    </svg>
  )
}

ClockIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}

export default React.memo(ClockIcon)
